:host {
  width: 100%;

  .lgr-tab-items-container {
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
    height: var(--lgr-spacing-xs);
    margin: 0 0 var(--lgr-spacing-nano) 0;
    padding: 0;
    border: none;
    list-style: none;
    overflow-x: auto;

    &.full-width {
      border-bottom: var(--lgr-border-size-default) solid var(--lgr-color-neutral-low-light);
    }

    &.inverse {
      border-color: var(--lgr-color-neutral-high-pure);
    }
  }
}
